import React from 'react';

import ToggleItem from '../../../modules/toggle-item/toggle-item';
import { SORT_DIRECTION } from '../../../types';

import './order-realizations-sorts.scss';

interface OrderRealizationsSortsProps {
  onItemToggle: (name: 'sum' | 'count', direction: SORT_DIRECTION) => void;
  directions: {
    count: SORT_DIRECTION;
    sum: SORT_DIRECTION;
  };
}

const OrderRealizationsSorts: React.FC<OrderRealizationsSortsProps> = ({
  directions,
  onItemToggle,
}) => (
  <div className="realization__sort">
    <div className="realization__sort-list">
      <div className="realization__sort-item">
        <ToggleItem title="Название позиций" />
      </div>
      <div className="realization__sort-item realization__sort-item--count">
        <ToggleItem
          title="Количество"
          direction={directions.count}
          onChangeToggle={(direction) => onItemToggle('count', direction)}
          toggle
        />
      </div>
      <div className="realization__sort-item realization__sort-item--sum">
        <ToggleItem
          title="Цена"
          direction={directions.sum}
          onChangeToggle={(direction) => onItemToggle('sum', direction)}
          toggle
        />
      </div>
    </div>
  </div>
);

export default OrderRealizationsSorts;
